import { render, staticRenderFns } from "./EducationalJoiningApplicationDelete.vue?vue&type=template&id=6733ab56&"
import script from "./EducationalJoiningApplicationDelete.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports